export const ASSIGN_CLASS_REQUEST = 'ASSIGN_CLASS_REQUEST'
export const ASSIGN_CLASS_SUCCESS = 'ASSIGN_CLASS_SUCCESS'
export const ASSIGN_CLASS_FALIURE = 'ASSIGN_CLASS_FALIURE'
